export default __webpack_public_path__ + "static/media/Nochatsfound.87ee8fc1.png";